import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { setTargetComponent, clearLookupData } from 'Modules/lookups/actions'

/**
 * Wrapper component for Link to display layout of the url lookup component
 * before lookup fetch is completed
 * Basically, faking url lookup from existing data in client-side with componentData
 */
const LookupLink = (props) => (
  <Link
    {...(R.omit(['componentData', 'setTargetComponent', 'clearLookupData'], props))}
    onClick={(e) => {
      if(props.onClick) props.onClick(e)
      if(!e.metaKey && !e.ctrlKey) {
        props.setTargetComponent(props.componentData)
        props.clearLookupData()
      }
    }}
  />
)

LookupLink.defaultProps = {
  componentData: {},
}

LookupLink.propTypes = {
  onClick: PropTypes.func,
  setTargetComponent: PropTypes.func,
  clearLookupData: PropTypes.func,
  componentData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    component: PropTypes.string,
  }),
}

export default connect(() => ({}), { setTargetComponent, clearLookupData })(LookupLink)
